import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserApi } from '../app/api/user.api';


export function Login(){

    const navigate = useNavigate();
    const user = UserApi();

    const [inputs, setInputs] = useState();
    const [status, setStatus] = useState(0);
    const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleInputs = ( event ) => {
        const { name , value } =  event.target ;
        setInputs( { ...inputs, [name] : value   } ) ;
    }
  
    const handleForm = async ( event ) => {
        event.preventDefault();
        setStatus(0);
        setIsLoading(true);
        try {
            const {data} = await user.auth(inputs);
            setIsLoading(false);
            if( data.success ){
                localStorage.setItem("token", data.token);
                navigate('/panel');
            }
            else{
                setStatus(-1);
                setMessage('Veuillez revoir vos informations');
            }

        } catch (err) { 
            setIsLoading(false);
            setStatus(-1);
            setMessage(err?.response.data.error);
            
        }
    } 

    return (

        <div className="container-fluid">
            <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light px-4">

                {/* ************************************************************************ */}  
                <div className="col-md-6 d-flex justify-content-center align-items-center px-4">
                  <div className="row d-flex justify-content-center">
                    <div className="col-md-12 rounded-2 py-4 px-4">

                        <form onSubmit={ handleForm } className="d-flex flex-column">
                          <div className=" d-flex flex-column align-items-center gap-2 mb-4" > 
                            <div className="d-flex mb-3" >
                              <span className="d-flex align-items-center justify-content-center border px-4 py-2 rounded-2 ">
                                 <img src={'../favicon.png'} className="" alt="Logement extérieur" style={{ width: "60px" }} />
                              </span>
                            </div>
                            <span className="lead color-green text-center"> Connexion </span>
                          </div>
                          {
                            isLoading && (
                              <div className="d-flex justify-content-center align-items-center mb-3"> 
                                <div className="spinner-border text-success" role="status" aria-label="Chargement"></div>
                              </div>
                            )
                          }
                          {
                            status === -1 && (
                              <div className="col-md-12 mb-2">
                                <div className="alert alert-danger"> { message } </div>
                              </div>
                            )
                          }
                          <input type="email" name="email" className="input border text-secondary p-3 rounded-2 mb-3" placeholder="Email" required onChange={ handleInputs } />
                          <div className="d-flex gap-1 mb-2 align-items-center mb-3">
                            <input type={showPassword ? "text" : "password"} name="password" placeholder="Mot de passe" className="input border text-secondary p-3 rounded-2 w-100" onChange={handleInputs} required />
                            <span className="d-flex align-items-center border p-3 rounded-2 text-secondary" style={{ cursor: "pointer" }} onClick={() => setShowPassword(!showPassword)}>
                              <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
                            </span>
                          </div>
                             
                          <button type="submit" className="btn btn-lg btn-green px-4 mt-2"> Connexion </button> 

                          <div className="mt-4 text-muted text-center">──────── ou ────────</div>

                          <div className="d-flex bg-white gap-2 border text-secondary rounded-2 py-3 px-4 text-outline-muted mt-4">
                            <span className='text-secondary'> Pas encore de compte : </span>
                            <a href="/inscription" className="nav-link color-green"> S'inscrire maintenant </a>
                          </div>

                          <div className="d-flex bg-white gap-2 border text-secondary rounded-2 py-3 px-4 text-outline-muted mt-3">
                            <span className='text-secondary'> Mot de passe oublié : </span>
                            <a href="/mp-oublie" className="nav-link color-green"> Modifier içi </a>
                          </div>
                   
                        </form>

                    </div>
                  </div>
                </div>
                 {/* ************************************************************************ */}  
              
            </div>
        </div>
        
    )
}


